import React from 'react'
import { Swiper } from 'swiper/react'
import SwiperCore, { Autoplay, EffectCoverflow } from 'swiper'
import { gsap, Power2, ScrollTrigger } from 'gsap/all'

import TitleCredits from './title-credits'

gsap.registerPlugin(ScrollTrigger)
SwiperCore.use([Autoplay, EffectCoverflow])

class CoverflowSlider extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
    }

    componentDidMount() {
        document.addEventListener('allimagesloaded', () => {
            gsap.from(this.domRef.current, {
                opacity: 0,
                y: 150,
                ease: Power2.easeOut,
                scrollTrigger: {
                    trigger: this.domRef.current,
                    toggleActions: 'restart',
                    start: 'top bottom',
                    end: 'top center',
                    scrub: true
                }
            })
        })
    }

    render() {
        const { title, artist, year, credit, initialSlide, children } = this.props

        return (
            <div className="coverflow-slider" ref={this.domRef}>
                <Swiper
                    effect="coverflow"
                    grabCursor
                    centeredSlides
                    slidesPerView="auto"
                    spaceBetween={16}
                    initialSlide={initialSlide}
                    autoplay
                    loop
                    coverflowEffect={{
                        rotate: 20,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: false
                    }}
                >
                    {children}
                </Swiper>
                <TitleCredits
                    title={title} 
                    artist={artist} 
                    year={year} 
                    credit={credit} 
                />
            </div>
        )
    }
}

export default CoverflowSlider